import React, { useEffect } from 'react';
import { Layout } from '../components/Layout';
import { Badge } from '../components/ui/badge';
import { TravelpayoutsWidget } from '../components/TravelpayoutsWidget';
import { AffiliateDisclosure } from '../components/AffiliateDisclosure';
import { Car, ShieldCheck, Clock, CreditCard } from 'lucide-react';

const PERKS = [
  { icon: Car, title: 'Door-to-door transfers', desc: 'Airport, hotel & city taxis in 150+ countries' },
  { icon: Clock, title: 'Meet & greet', desc: 'Driver tracks your flight and waits for you' },
  { icon: CreditCard, title: 'Fixed price', desc: 'Confirmed fare upfront — no surge, no surprises' },
  { icon: ShieldCheck, title: 'Vetted drivers', desc: 'Licensed local partners, 24/7 support' },
];

export default function Transfers() {
  useEffect(() => { document.title = 'Taxi & Airport Transfers | FlightDeals.in'; }, []);
  return (
    <Layout>
      <section className="bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Badge className="rounded-full bg-accent/15 text-accent mb-2"><Car className="h-3.5 w-3.5 mr-1" />Taxi & Transfers</Badge>
          <h1 className="font-display text-3xl font-semibold flex items-center gap-2">Book airport taxis & transfers</h1>
          <p className="text-primary-foreground/75 mt-1 max-w-2xl">Reserve a private transfer in advance with a fixed price — your driver meets you on arrival. Powered by our trusted transfer partner.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4 mb-6">
          {PERKS.map((p) => (
            <div key={p.title} className="rounded-2xl border border-border bg-card p-4" data-testid={`transfer-perk-${p.title.split(' ')[0].toLowerCase()}`}>
              <p.icon className="h-5 w-5 text-accent mb-2" />
              <p className="font-semibold text-sm">{p.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mb-4"><AffiliateDisclosure variant="banner" /></div>

        <div className="rounded-2xl border border-border bg-card p-4" data-testid="transfer-widget-wrap">
          <p className="text-xs uppercase tracking-wide text-muted-foreground mb-2">Search transfers</p>
          <TravelpayoutsWidget
            src="https://tpwidg.com/content?trs=564663&shmarker=766935&locale=en&powered_by=true&color_scheme=bg&header=book%20your%20transfers%20from%20flightdeals.in&b_counter=true&b_benefit=true&b_descr=true&b_about=true&b_map=true&b_reviews=true&b_breadcrumbs=true&b_poweredby=true&b_numbers=true&b_trustpilot=true&b_assortment=true&b_reliable=true&b_extended=true&b_how=true&b_faq=true&b_why=true&b_easybook=true&campaign_id=22&promo_id=1504"
            testid="transfer-widget"
            minHeight={120}
          />
        </div>
      </section>
    </Layout>
  );
}
